export default [
	{
        path: '/dashboard',
        component: () => import('../components/Dashboard.vue'),
        name: 'admin-dashboard',
        meta: {                  
        }
    },

]